import { useState, useEffect, useRef } from "react";
import { Box, Grid, Typography, Paper, Alert } from "@mui/material";
import { getData } from "../../../../services/library";
import Comprobanteexiste from "./Comprobanteexiste";
import InfoIcon from "@mui/icons-material/Info";
import Snackbar from "@mui/material/Snackbar";

//CUSTOM IMPORTS
import CabeceraComprobante from "./CabeceraComprobante";
import DetalleComprobante from "./DetalleComprobante";
import ImpuestosComprobante from "./ImpuestosComprobante";
import ResumenImportesComprobante from "./ResumenImportesComprobante";
import { UrlApi } from "../../../../services/apirest";
import { authHeader } from "../../../../services/services";
import { armarNroComprobante, esComprobanteBanco } from "../functions";

function TituloSeccion({ children }) {
  return (
    <Box sx={{ borderBottom: 1, borderColor: "divider", mt: 0.5 }}>
      <Typography
        variant="subtitle2"
        sx={{
          color: "#1f618d",
          fontWeight: "bold",
          textAlign: "center",
          py: 0.5,
        }}
      >
        {children}
      </Typography>
    </Box>
  );
}

export default function FormComprobante({
  formatoCalculo,
  proveedores,
  tiposComprobantes,
  sucursales,
  impuestos,
  tipoMoneda,
  condicionesPago,
  valorPorcentajes,
  imputaciones,
  setImputaciones,
  setotrosTributos,
  otrostributos,
  datosCabecera,
  setdatosCabecera,
  setdatosCuerpo,
  datosCuerpo,
  datosImpuestos,
  setdatosImpuestos,
  datosPie,
  setdatosPie,
  proveedorSelected,
  setproveedorSelected,
  comprobanteSelected,
  setcomprobanteSelected,
  total,
  setTotal,
  comprobanteExiste,
  setcomprobanteExiste,
  setnetoGravado,
  neto,
  saldonoaplic,
  setsaldonoaplic,
  style,
  getProveedores,
  setProveedores,
  setGuardarImputacProveedor,
  formatNumber,
  totalMuestro,
  handleOnChangeTotal,
  saldoNegativo,
  setSaldoNegativo,
  loading,
  handleAddProveedor,
  handleCloseAddProveedor,
  handleOnBlurTotal,
  empresas,
  empresaFija,
  filaArca,
  bloqueoArca,
  bloqueoProveedorArca,
  setIdArcaImportado,
  bancos,
  imputacionProveedor,
  setimputacionProveedor,
  muestroDiferencia,
  setmuestroDiferencia
  // handleOnBlurMontoMaximo
  // condVentaNew,
  // setdisbtn,
  // validarFormulario,
  // setcondVentaNew,
  // calcularSubtotalIva,
  // setCalcularSubtotalIva,
  // montoMaximo,
  // ordenes,
  // ordenesForm
  // periodos
  // periodoSelected
  // setperiodoSelected
  // setOrdenes
  // setordenesForm
}) {
  /* ----------------------------ESTADOS Y REFS-------------------------------  */

  //Estados que manejan componentes visuales
  const [modal, setModal] = useState(false);
  const iconInfo = <InfoIcon sx={{ fontSize: 40 }} />;
  const timeoutRef = useRef(null);
  const [inputValue, setInputValue] = useState("");
  const [alert, setAlert] = useState();

  // const [showTabs, setShowTabs] = useState(true);
  // const [modalmontoMaximo, setmodalmontoMaximo] = useState(false);

  /* --------------------------- HANDLERS --------------------------------  */
  const almacenarCabecera = (e) => {
    const { name, value } = e.target;

    setdatosCabecera((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // const setearPeriodo = (e) => {
  //     setperiodoSelected(e.target.value)
  // };

  const handleOnChangeProvSel = async (e, proveedor) => {
    setdatosCabecera((prev) => ({
      ...prev,
      // id_imputacion: "",
      id_condicionpago: proveedor?.id_condicionventa || "",
      id_proveedor: Boolean(proveedor?.padron) === true ? null : proveedor.id
    }));

    setImputaciones([])
    setproveedorSelected(proveedor);
    // if (Boolean(proveedor?.padron) === false) {
    if (proveedor.padron === 0) {
      const res = await fetch(
        UrlApi + `/imputacion_proveedores/xid/${proveedor.id}`
      );
      const json = await res.json();

      if (!json.length) {
        //El proveedor no tiene imputaciones de gasto asociadas, por lo tanto, le muestro todas las registradas para que elija una: 
        getData("/imputacion_gastos", setImputaciones);
        setGuardarImputacProveedor(true) //como el prov no tiene imputaciones, guardo la del comprobante.
        setImputaciones(json);
        setAlert(true);
      } else {
        setGuardarImputacProveedor(false)
        setimputacionProveedor(json)
        getData("/imputacion_gastos", setImputaciones);
      }
    } else {
      setAlert(true);
      getData("/imputacion_gastos", setImputaciones);
      setGuardarImputacProveedor(false) //Lo pongo en false porque cuando es un proveedor de padron, en el backend ya guarda todo, sin necesidad de esta bandera.
    }
  };

  /* --------------------------- EFFECTS --------------------------------  */
  useEffect(() => {
    if (!comprobanteSelected) return;
    if (!datosCabecera?.comprobante_nro) return;

    if (esComprobanteBanco(comprobanteSelected) && !datosCabecera?.id_banco) return;
    if (!esComprobanteBanco(comprobanteSelected) && !datosCabecera?.comprobante_pv) return;

    // Detección de duplicados (requiere proveedor seleccionado)
    if (proveedorSelected) {
      const nroComprobante = armarNroComprobante(comprobanteSelected, datosCabecera);
      getData(
        "/comprobantes_cabecera/xidpynro/" +
          comprobanteSelected.id_tipo_comprobante +
          "/" +
          proveedorSelected.cuit +
          "/" +
          nroComprobante,
        setcomprobanteExiste
      );
    }

    // Modo ARCA: lookup + prefill. Usa el CUIT del proveedor o, si no matcheó el
    // padrón (fila "sin proveedor"), el CUIT de la fila importada.
    if (empresaFija?.id != null) {
      const cuitArca = proveedorSelected?.cuit || filaArca?.cuit_emisor;
      if (!cuitArca) return;
      const params = new URLSearchParams({
        id_empresa: empresaFija.id,
        cuit: cuitArca,
        tipo: comprobanteSelected.id_tipo_comprobante,
        pv: datosCabecera.comprobante_pv,
        nro: datosCabecera.comprobante_nro,
      });
      fetch(UrlApi + "/comprobantes_arca/lookup?" + params.toString(), {
        headers: authHeader(),
      })
        .then((r) => r.json())
        .then((row) => {
          if (!row) {
            setIdArcaImportado?.(null);
            return;
          }
          const fmt = (n) =>
            new Intl.NumberFormat("es-AR", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            }).format(Number(n) || 0);
          const uuidComp = datosCuerpo?.[0]?.uuid_comprobante;
          const usuario = localStorage.getItem("user");
          const lineas = (row.lineas || []).map((l) => ({
            subtotal: fmt(l.neto),
            monto_iva: fmt(l.monto_iva),
            subtotal_iva: fmt(Number(l.neto) + Number(l.monto_iva)),
            id_porcentajeiva: l.id_porcentajeiva,
            detalle_productos: null,
            id_imputacion: null,
            uuid_comprobante: uuidComp,
            usuario,
          }));
          setdatosCabecera((prev) => ({
            ...prev,
            fecha_factura: row.fecha_emision ?? prev.fecha_factura,
            tipo_cambio: row.tipo_cambio ?? prev.tipo_cambio,
            neto_gravado: row.neto_gravado_total ?? prev.neto_gravado,
            otros_tributos: row.otros_tributos ?? prev.otros_tributos,
            total: row.imp_total ?? prev.total,
          }));
          if (lineas.length) setdatosCuerpo(lineas);
          if (row.imp_total != null && handleOnChangeTotal) {
            handleOnChangeTotal({
              target: { value: String(row.imp_total).replace(".", ",") },
            });
          }
          // Otros Tributos: el CSV trae solo el total → se precarga en la línea "Otros"
          // (índice 2 de las 3 líneas fijas) para que Compras lo redistribuya si hace falta.
          if (row.otros_tributos != null && Number(row.otros_tributos) > 0) {
            setdatosImpuestos((prev) =>
              prev.map((it, i) =>
                i === 2 ? { ...it, importe: fmt(row.otros_tributos) } : it
              )
            );
          }
          setIdArcaImportado?.(row.id);
        })
        .catch((e) => console.error("Error lookup ARCA:", e));
    }
  }, [
    proveedorSelected,
    comprobanteSelected,
    datosCabecera.comprobante_pv,
    datosCabecera.comprobante_nro,
    datosCabecera.id_banco,
    filaArca,
  ]);

  useEffect(() => {
    comprobanteExiste?.length > 0 ? setModal(true) : setModal(false)
  }, [comprobanteExiste]);

  useEffect(() => {
    if (!datosCabecera.fecha_factura || !datosCabecera.id_condicionpago) return;

    const dias = condicionesPago?.find(
      (cond) => cond.id === datosCabecera.id_condicionpago
    )?.dias;

    const fecha = new Date(datosCabecera.fecha_factura);

    if (dias && Number(dias) > 0) {
      fecha.setDate(fecha.getDate() + Number(dias));
    }

    const vto = fecha.toISOString().split("T")[0];

    setdatosCabecera((prev) => ({
      ...prev,
      vto_factura: vto,
    }));
  }, [
    datosCabecera.fecha_factura,
    datosCabecera.id_condicionpago,
    condicionesPago,
  ]);

  /* --------------------------- RENDER --------------------------------  */


  return (
    <div>
      <Paper
        elevation={3}
        sx={{
          background: "linear-gradient(to right, #f8f9fa, #e8f0fe)",
          mt: 1,
          p: 2,
          borderRadius: 4,
          borderLeft: "6px solid #1f618d",
        }}
      >
        <CabeceraComprobante
          loading={loading}
          formatNumber={formatNumber}
          datosCabecera={datosCabecera}
          almacenarCabecera={almacenarCabecera}
          tiposComprobantes={tiposComprobantes}
          comprobanteSelected={comprobanteSelected}
          setcomprobanteSelected={setcomprobanteSelected}
          bancos={bancos}
          proveedores={proveedores}
          proveedorSelected={proveedorSelected}
          inputValue={inputValue}
          setInputValue={setInputValue}
          sucursales={sucursales}
          timeoutRef={timeoutRef}
          condicionesPago={condicionesPago}
          tipoMoneda={tipoMoneda}
          getProveedores={getProveedores}
          setProveedores={setProveedores}
          imputaciones={imputaciones}
          setproveedorSelected={setproveedorSelected}
          style={style}
          handleOnChangeProvSel={handleOnChangeProvSel}
          total={total}
          setTotal={setTotal}
          totalMuestro={totalMuestro}
          handleOnChangeTotal={handleOnChangeTotal}
          handleAddProveedor={handleAddProveedor}
          handleCloseAddProveedor={handleCloseAddProveedor}
          handleOnBlurTotal={handleOnBlurTotal}
          empresas={empresas}
          empresaFija={empresaFija}
          bloqueoArca={bloqueoArca}
          bloqueoProveedorArca={bloqueoProveedorArca}

        // handleOnBlurMontoMaximo={handleOnBlurMontoMaximo}
        // handleOnChangeFechaComprobante={handleOnChangeFechaComprobante}
        // periodos={periodos}
        // periodoSelected={periodoSelected}
        // setearPeriodo={setearPeriodo}
        />
      </Paper>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="top"
      >
        <Grid item xs={8.6}>
          <TituloSeccion>Detalle</TituloSeccion>
          <DetalleComprobante
            datosCuerpo={datosCuerpo}
            setdatosCuerpo={setdatosCuerpo}
            valorPorcentajes={valorPorcentajes}
            formatNumber={formatNumber}
            imputaciones={imputaciones}
            setGuardarImputacProveedor={setGuardarImputacProveedor}
            imputacionProveedor={imputacionProveedor}
            setimputacionProveedor={setimputacionProveedor}
            proveedorSelected={proveedorSelected}
            comprobanteSelected={comprobanteSelected}
            muestroDiferencia={muestroDiferencia}
            setmuestroDiferencia={setmuestroDiferencia}
            bloqueoArca={bloqueoArca}
          />
          <TituloSeccion>Percepciones/Otros tributos</TituloSeccion>
          <ImpuestosComprobante
            impuestos={impuestos}
            datosImpuestos={datosImpuestos}
            setdatosImpuestos={setdatosImpuestos}
            formatNumber={formatNumber}
            muestroDiferencia={muestroDiferencia}
            setmuestroDiferencia={setmuestroDiferencia}
            empresaFija={empresaFija}
          />
        </Grid>
        <Grid item xs={3.3}>
          <ResumenImportesComprobante
            saldoNegativo={saldoNegativo}
            setSaldoNegativo={setSaldoNegativo}
            total={total}
            totalMuestro={totalMuestro}
            datosCuerpo={datosCuerpo}
            neto={neto}
            setnetoGravado={setnetoGravado}
            otrostributos={otrostributos}
            setotrosTributos={setotrosTributos}
            saldonoaplic={saldonoaplic}
            setsaldonoaplic={setsaldonoaplic}
            datosImpuestos={datosImpuestos}
            valorPorcentajes={valorPorcentajes}
            datosPie={datosPie}
            setdatosPie={setdatosPie}
            formatNumber={formatNumber}
            formatoCalculo={formatoCalculo}
          // tiposIvaSeleccionados={tiposIvaSeleccionados}
          />
        </Grid>
      </Grid>
      <Comprobanteexiste
        handleClose={() => {
          setModal(false)
          setdatosCabecera((prev) => ({
            ...prev,
            comprobante_pv: "",
            comprobante_nro: "",
            id_banco: null,
            concepto: "",
          }))
        }}
        open={modal}
        setOpen={setModal}
        title="Comprobante existente"
        subtitle="El comprobante que intenta cargar ya existe en el sistema."
        color="#e74c3c"
        icon={iconInfo}
        confirmText="Por favor verifique los datos."
      />
      <Snackbar open={alert} autoHideDuration={3000} onClose={() => setAlert(false)} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert
          onClose={() => setAlert(false)}
          severity="warning"
          variant="filled"
          sx={{ width: "100%" }}
        >
          Este proveedor no tiene cargadas imputaciones. Elija una de la lista.
        </Alert>
      </Snackbar>
    </div>
  );
}
